import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { IonApp, IonRouterOutlet, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import Home from './pages/Home';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import Modul from './pages/Modul';
import ModulDyn from './pages/ModulDyn';
import Schlagwort from './pages/Schlagwort';
import Infos from './pages/Infos';

setupIonicReact();

const App: React.FC = () => (
  <IonApp>
    <IonReactRouter>
      <IonRouterOutlet>
        <Route exact path="/Modul/">
          <Modul />
        </Route>
        <Route exact path="/ModulDyn/:modul">
          <ModulDyn />
        </Route>
        <Route exact path="/Schlagwort/:modul">
          <Schlagwort />
        </Route>
        <Route exact path="/home">
          <Home />
        </Route>
        <Route exact path="/Infos">
          <Infos />
        </Route>
        <Route exact path="/">
          <Redirect to="/home" />
        </Route>
        
      </IonRouterOutlet>
    </IonReactRouter>
  </IonApp>
);

export default App;
